import "../../../Css/TicketDetails.css";
import { useState } from "react";
import TransferTicket from "./TransferTicket";
import NewTicket from "./NewTicket";
//js
import { CallService, modalAlert } from "../../../Js/Script";
import { UseTicket, SetTicket } from "../../../Js/Context/TicketCntx";
export default function TicketDetailsHeader({
  targetUser,
  writerUser,
  ticketId,
}) {
  const [ShowNewResponseTicketComponent, setShowNewResponseTicketComponent] =
    useState(false);
  const [ShowTransferTicketComponent, setShowTransferTicketComponent] =
    useState(false);
  const ticket = UseTicket();
  const setTicket = SetTicket();
  //const [states, setStates] = useState({
  //    SatisfactionSurveyTxt:
  //        "با اعلام میزان رضایتمندی خود ما را در ارائه خدمات بهتر یاری نمایید.",
  //});
  function StarRating({ starCount }) {
    const stars = Array.from({ length: starCount }, (_, index) => index + 1);
    return (
      <div className="flexRow" id="starRating">
        (
        {stars.map((star) => (
          <div key={star}>&#9733;</div>
        ))}
        )
      </div>
    );
  }

  //function submitSatisfactionSurvey(num) {
  //    if (num == 1) {
  //        setStates((prevState) => ({
  //            ...prevState,
  //            SatisfactionSurveyTxt:
  //                "از اینکه توانستیم رضایت شما را جلب نماییم خوشحالیم.",
  //        }));
  //    } else if (num == 2) {
  //        setStates((prevState) => ({
  //            ...prevState,
  //            SatisfactionSurveyTxt:
  //                "سعی خواهیم نمود تا در تیکت های بعدی، بیشتر رضایت شما را جلب نماییم.",
  //        }));
  //    } else if (num == 3) {
  //        setStates((prevState) => ({
  //            ...prevState,
  //            SatisfactionSurveyTxt:
  //                "متأسفیم که نتوانستیم رضایت شما را جلب نماییم.",
  //        }));
  //    }
  //}
  const changeTicketStatus = (id, status) => {
    CallService(
      `Tickets/${id}/ToggleStatus`,
      { status: status },
      "PUT",
      false,
      false
    )
      .then((res) => {
        setTicket((prev) => ({
          ...prev,
          dataStatus: `${res.status}`,
        }));
      })
      .catch((err) => {
        modalAlert(err.message, "خطا");
      });
  };
  return (
    <div>
      {ShowTransferTicketComponent && (
        <TransferTicket
          setShowTransferTicketComponent={setShowTransferTicketComponent}
          showTransferTicketComponent={ShowTransferTicketComponent}
          ticketId={ticket && ticketId ? ticketId : ""}
        />
      )}
      {ShowNewResponseTicketComponent && (
        <NewTicket
          setShowNewResponseTicketComponent={setShowNewResponseTicketComponent}
          ticketInformation={ticket}
          responseTicket={true}
        />
      )}
      <div
        id="ticketDetails-header"
        className={`flexRow justify-between ${
          ShowTransferTicketComponent ? "ticketDetails-header-hide" : ""
        }`}
      >
        <p classname={`flexrow ${ShowTransferTicketComponent ? "none" : ""}`}>
          وضعیت تیکت :{" "}
          {ticket && ticket["dataStatus"] == "true" ? "باز" : "بسته"}
        </p>
        <div
          style={{ width: "fit-content" }}
          className={`flexRow ${ShowTransferTicketComponent ? "none" : ""}`}
        >
          {targetUser ? (
            <button
              id="ticket-transfer"
              className="btn-default"
              onClick={() => {
                setShowTransferTicketComponent(true);
              }}
            >
              ارجاع
            </button>
          ) : (
            ""
          )}
          {targetUser ? (
            <div>
              {ticket && ticket["dataStatus"] == "false" ? (
                <button
                  id="ticket-opening"
                  className="btn-primary"
                  onClick={() => {
                    changeTicketStatus(ticketId, true);
                  }}
                >
                  دوباره باز کردن تیکت
                </button>
              ) : (
                <div>
                  {targetUser ? (
                    <button
                      id="ticket-reply"
                      className="btn-primary"
                      onClick={() => {
                        setShowNewResponseTicketComponent(true);
                      }}
                    >
                      پاسخ به تیکت
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    id="ticket-close"
                    className="btn-success"
                    onClick={() => {
                      changeTicketStatus(ticketId, false);
                    }}
                  >
                    بستن
                  </button>
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
